import React from "react";
import { ProgressBar } from "react-bootstrap";

const Skills = () => {
    return (
        <div>
            <div className="container-md">
                <h2 className="my-4">My Skills</h2>
                <div className="row justify-content-center g-4">
                    <div className="col-md-5 bg-dark rounded p-2 m-3">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">Html</span>
                            <span className="p-2 rounded">90%</span>
                        </h4>
                        <ProgressBar variant="success" now={90} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">Css</span>
                            <span className="p-2 rounded">92%</span>
                        </h4>
                        <ProgressBar variant="success" now={92} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">BootStrap</span>
                            <span className="p-2 rounded">85%</span>
                        </h4>
                        <ProgressBar variant="success" now={85} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">Material UI</span>
                            <span className="p-2 rounded">40%</span>
                        </h4>
                        <ProgressBar variant="warning" now={40} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">Tailwind</span>
                            <span className="p-2 rounded">35%</span>
                        </h4>
                        <ProgressBar variant="warning" now={35} />
                    </div>

                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">JavaScript</span>
                            <span className="p-2 rounded">70%</span>
                        </h4>
                        <ProgressBar variant="primary" now={70} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">ReactJS</span>
                            <span className="p-2 rounded">75%</span>
                        </h4>
                        <ProgressBar variant="primary" now={75} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">NodeJS</span>
                            <span className="p-2 rounded">70%</span>
                        </h4>
                        <ProgressBar variant="primary" now={70} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">ExpressJS</span>
                            <span className="p-2 rounded">80%</span>
                        </h4>
                        <ProgressBar variant="success" now={80} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">MongoDB</span>
                            <span className="p-2 rounded">80%</span>
                        </h4>
                        <ProgressBar variant="success" now={80} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">Next JS</span>
                            <span className="p-2 rounded">Learning</span>
                        </h4>
                        <ProgressBar variant="secondary" animated now={25} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">Redux</span>
                            <span className="p-2 rounded">Learning</span>
                        </h4>
                        <ProgressBar variant="secondary" animated now={25} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">React Native</span>
                            <span className="p-2 rounded">Learning</span>
                        </h4>
                        <ProgressBar variant="secondary" animated now={25} />
                    </div>
                    <div className="col-md-5 bg-dark p-2 m-3 rounded">
                        <h4 className="d-flex justify-content-between">
                            <span className="p-2 rounded">TypeScript</span>
                            <span className="p-2 rounded">Learning</span>
                        </h4>
                        <ProgressBar variant="secondary" animated now={25} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;
